// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  IGetStatusAboutCreatedMessageChatMessageRequest,
  TGetStatusAboutCreatedMessageChatMessageModel,
  IMappers,
  TGetStatusAboutCreatedMessageChatMessageResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetStatusAboutCreatedMessageChatMessageResponse } from '../../entities/get_status_about_created_message_chat_message/GetStatusAboutCreatedMessageChatMessageResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetStatusAboutCreatedMessageChatMessageModel(
  parameters: IGetStatusAboutCreatedMessageChatMessageRequest,
): TGetStatusAboutCreatedMessageChatMessageModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'demand',
    pathApi: '/v1/get-status-about-created-message-chat-message/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetStatusAboutCreatedMessageChatMessageOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetStatusAboutCreatedMessageChatMessageRequest;
}

export async function fetchGetStatusAboutCreatedMessageChatMessage<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetStatusAboutCreatedMessageChatMessageOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetStatusAboutCreatedMessageChatMessageResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetStatusAboutCreatedMessageChatMessageModel(parameters),
    config,
  )) as FetchResponse<TGetStatusAboutCreatedMessageChatMessageResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetStatusAboutCreatedMessageChatMessageResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetStatusAboutCreatedMessageChatMessageResponse>;
}
